import React from "react";
import "./Modals.scss";

let openModal;
let closeModal;
let copyToClipboard;
let openImageModal;

class Modals extends React.Component {
	state = { active: false, locked: false, modals: [], closing: [] };

	componentDidMount() {
		openModal = modal => {
			if (this.state.locked)
				return;
			
			const modals = this.state.modals;
			modals.push(modal);
			this.setState({ modals, active: true });
		};

		closeModal = () => {
			if (this.state.modals.length > 0) {
				const modals = [...this.state.modals];
				const modal = this.state.modals[modals.length - 1];
				const closing = [...this.state.closing];

				modals.pop(modal);
				closing.push(modal);
	
				if (this.state.active) {
					this.setState({ active: modals.length > 0, locked: true, closing });
					setTimeout(() => {
						this.state.closing.pop(modal);
						this.setState({ modals, locked: false });
					}, 300);
				}
			}
		};

		copyToClipboard = text => {
			navigator.clipboard.writeText(text);

			openModal((
				<div className="ClipboardModal" onClick={() => closeModal()}>
					<span>
						"{text}" copied to clipboard!
					</span>
				</div>
			));
		};

		openImageModal = url =>
			openModal(
				<div className="ImageModal" onClick={() => closeModal()} style={{ backgroundImage: `url(${url})` }}/>
			);
	}

	render() {
		return (
			<div className={"ModalContainer" + (this.state.active ? " Active" : "")}
				onClick={e => {if (e.target == e.currentTarget || e.target.classList.contains("Modal")) closeModal()}}>
				{ this.state.modals.map(modal => (
					<div key={this.state.modals.indexOf(modal)} className={"Modal" + (this.state.closing.includes(modal) ||
						(this.state.modals.indexOf(modal) < (this.state.modals.length - 1) && this.state.closing.length == 0) ? " Closing" : "")}
						style={{ zIndex: this.state.modals.indexOf(modal) * 10 }}>
						{ modal }
					</div>
				)) }
			</div>
		);
	}
}

export { Modals, openModal, closeModal, copyToClipboard, openImageModal };